import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import ApiUsage from "@/modules/api-usage/ApiUsage.vue";

const routes = [
  {
    path: 'api-usage',
    name: 'api_usage',
    component: ApiUsage,
    meta: {
      requiresAuth: true
    }
  },
];

MenuService.addMenuItem(new MenuItem('/api-usage', i18n.t('API usage'), 5, 'file-invoice-dollar', [], 'view_api_usage'));

export {routes}
